<template>
  <BaseModal modalColor="border-success bg-primary" iconModal="fa fa-edit" subtitulo="Cadastrar novo usuário"
             col-md="col-md-3" offset="3">
    <template v-slot:modalContent>
      <form ref="cadastroForm" @submit.prevent="submitIncluirForm">
        <div class="box-body">
          <div class="form-group" v-if="isAdminView">
            <FloatLabel variant="on">
              <Select
                  v-model="dado.empresa"
                  inputId="empresa"
                  :options="empresas"
                  optionLabel="razao_social"
                  optionValue="id"
                  size="small"
                  filter
                  style="width: 100%"
                  :invalid="campoVazio.includes('empresa')"
              >
                <template #emptyfilter>
                  Nenhum resultado encontrado
                </template>
              </Select>
              <label for="empresa">
                <strong>Empresa: <span class="text-danger font-bold">*</span></strong>
              </label>
            </FloatLabel>
          </div>
          <div class="form-group">
            <FloatLabel variant="on">
              <InputText id="first_name" v-model="dado.first_name" size="small" style="width: 100%"/>
              <label for="first_name"><strong>Nome: </strong></label>
            </FloatLabel>
          </div>
          <div class="form-group">
            <FloatLabel variant="on">
              <InputText id="last_name" v-model="dado.last_name" size="small" style="width: 100%"/>
              <label for="last_name"><strong>Sobrenome: </strong></label>
            </FloatLabel>
          </div>
          <div class="form-group">
            <FloatLabel variant="on">
              <InputText type="email" id="email" v-model="dado.email" size="small"
                         :invalid="campoVazio.includes('email')" style="width: 100%"/>
              <label for="email"><strong>E-mail: <span
                  class="text-danger font-bold">*</span></strong></label>
            </FloatLabel>
          </div>
          <div class="form-group" v-if="isAdminView">
            <Checkbox v-model="dado.is_staff" :binary="true" inputId="is_staff"/>
            <label for="is_staff"><strong>Equipe</strong></label>
          </div>
          <div class="form-group" v-if="isAdminView">
            <Checkbox v-model="dado.is_superuser" :binary="true" inputId="is_superuser"/>
            <label for="is_superuser"><strong>Super Usuário</strong></label>
          </div>
          <div class="ibox-footer">
            <div class="float-right">
              <button type="submit" class="btn btn-primary font-bold">Confirmar</button>
            </div>
            <button class="btn btn-danger font-bold" @click="$emit('fechar')">
              Cancelar
            </button>
          </div>
        </div>
      </form>
    </template>
  </BaseModal>
</template>

<script>
import BaseModal from '@/components/base/BaseModal.vue';
import {apiRequest} from "../../../public/js/utils/funcoes";
import {apiUrl} from "@/router/apiBackRoutes";


export default {
  name: "CadastraClientes",
  components: {
    BaseModal,
  },
  props: {
    isAdminView: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      empresas: [],
      dado: {
        username: "",
        first_name: "",
        last_name: "",
        email: "",
        is_active: true,
        is_staff: false,
        is_superuser: false,
        empresa: null,
      },
      campoVazio: [],
    }
  },
  emits: ["fechar", "atualizarListaUsuarios"],
  methods: {
    async getEmpresas() {
      const resultado = await apiRequest("GET", `${apiUrl.empresas.createList}?status=A`);
      if (resultado.success) {
        this.empresas = resultado.data.results;
      } else {
        this.$toastMessage("warn", "Atenção", "Erro ao carregar empresas!");
        console.error("Erro ao carregar:", resultado.error);
      }
    },
    async submitIncluirForm() {
      this.dado.username = this.dado.email;
      const url = this.isAdminView ? apiUrl.usuarios.adminCreateList : apiUrl.usuarios.createList;
      const resultado = await apiRequest("POST", url, this.dado);
      if (resultado.success) {
        this.$emit("atualizarListaUsuarios", resultado.data);
        this.$toastMessage("warn", "Registro salvo com sucesso!", `Senha: ${resultado.data.temp_password}`);
        this.$emit('fechar');
      } else {
        this.campoVazio = Object.keys(resultado.error);
        if (resultado.error && typeof resultado.error === "object") {
          for (const campo in resultado.error) {
            resultado.error[campo].forEach(msg => {
              this.$toastMessage("error", campo, msg);
            });
          }
        } else {
          this.$toastMessage("warn", "Atenção", "Erro inesperado ao salvar!");
        }
      }
    },
  },
  mounted() {
    if (this.isAdminView) {
      this.getEmpresas();
    }
  }
}
</script>

<style>
.p-checkbox + label {
  margin-left: 0.5rem;
}
</style>
